import Catalogue from "~/modules/catalogue/Catalogue";
import styles from "./partner.module.css";
import { Outlet, useLoaderData, useOutletContext } from "@remix-run/react";
import ReminderToBecomeExpert from "~/components/reminder-to-become-expert/reminder-to-become-expert";
import ContactButtonConfigured from "~/modules/addons/components/contact-button-configured/contact-button-configured";
import { useGlobalStyles } from "~/styles/context/global-styles-wrapper";
import { HomeWidget } from "@commons-monorepo/index";
import AddonPopup from "~/modules/addons/containers/addon-popup";

export default function Index() {
  const { paginatedData, home } = useLoaderData();
  const { theme } = useGlobalStyles();
  const { storeMetadata, url } = useOutletContext<any>();
  const isSubdomain = url.includes(".dev.domun");
  const storeIsPrime = !!storeMetadata.prime;
  const data = useOutletContext<any>();
  const widgets =
  home?.widgets?.sort((a: HomeWidget, b: HomeWidget) => a.index - b.index) ||
  [];

  return (
    <>
      <AddonPopup />
      <ContactButtonConfigured />
      <div className={styles.wrapperMainCatalogue} role='catalogue'>
        {(data?.storeUseSubdomain || data?.storeUseDomain) &&
        !storeIsPrime &&
        !isSubdomain && <ReminderToBecomeExpert />}
        <div className={styles.desktopGrid}>
          <Catalogue
            products={paginatedData.products}
            theme={theme}
            widgets={widgets} />

        </div>
        <Outlet context={data} />
      </div>
    </>);

}